module.exports = __webpack_public_path__ + "img/favicon.d3787beb.png";